export default __webpack_public_path__ + "static/media/Whangaehu.d31b48c5.png";